module.exports = __webpack_public_path__ + "img/CS-Lite-Overview.8dd7b68d.jpg";